var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 9,
    viewBox: "0 0 45 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86735 0.225764L0.0532227 8.78063H1.84957L2.42463 6.12465H4.09648C6.27817 6.12465 7.79588 4.8263 7.79588 2.7276C7.79588 1.21583 6.68131 0.225764 4.99168 0.225764H1.86735ZM3.36727 1.69604H4.56483C5.44818 1.69604 5.97582 2.11104 5.97582 2.89953C5.97582 3.97259 5.21697 4.67216 4.07276 4.67216H2.71513L3.36727 1.69604Z",
    fill: "#595959"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5216 1.61304C13.6718 1.61304 14.4425 2.47268 14.4425 3.77695C14.4425 5.84008 13.233 7.39928 11.6798 7.39928C10.5178 7.39928 9.74707 6.53964 9.74707 5.23537C9.74707 3.19596 10.9743 1.61304 12.5216 1.61304ZM11.6086 8.99998C14.2705 8.99998 16.2803 6.80643 16.2803 3.64059C16.2803 1.56561 14.8634 0.00640869 12.5928 0.00640869C9.93086 0.00640869 7.90923 2.21775 7.90923 5.3658C7.90923 7.44078 9.36765 8.99998 11.6086 8.99998Z",
    fill: "#595959"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2929 8.78063H18.0951L18.7591 5.68001H20.2887L21.3084 8.78063H23.2352L22.0613 5.47251C23.3656 5.04566 24.1778 3.90738 24.1778 2.65053C24.1778 1.22768 23.081 0.225764 21.4981 0.225764H18.1129L16.2929 8.78063ZM19.6188 1.67232H21.0891C21.8835 1.67232 22.3518 2.08732 22.3518 2.8106C22.3518 3.68802 21.6523 4.30459 20.6029 4.30459H19.0378L19.6188 1.67232Z",
    fill: "#595959"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8364 8.78063L29.3423 1.75532H31.9034L32.2176 0.225764H25.2931L24.9789 1.75532H27.54L26.0342 8.78063H27.8364Z",
    fill: "#595959"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3723 2.01025H35.4849L35.8288 5.35987H33.57L35.3723 2.01025ZM36.1193 8.78063H37.9631L36.8544 0.225764H34.7854L29.924 8.78063H31.7915L32.8942 6.74121H35.9118L36.1193 8.78063Z",
    fill: "#595959"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6274 7.22142H40.8272L42.3272 0.225764H40.5308L38.7108 8.78063H44.3073L44.6274 7.22142Z",
    fill: "#595959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.640e2113b139d86de2143b45fd1dd109.svg";
export { ForwardRef as ReactComponent };